import styled from 'styled-components';

export const LoaderStyles = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
